// Preview submission's place in the URL (BRK-S357): `?preview=1` opens the
// read-only panel over the submission's page. Opening pushes an entry, so the
// browser's Back closes it, and a link opens it directly, as the quote
// popup's `?quote=` does (BRK-S347, `useUrlOverlay`).

export const PREVIEW_PARAM = "preview";

/** The mark on an entry the panel pushed. */
export const PREVIEW_MARK = "previewPanel";

/** Whether the URL opens the panel. */
export function readPreviewPanel(params: URLSearchParams): boolean {
  return params.get(PREVIEW_PARAM) === "1";
}
